import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase, Menu, MenuItem, Typography } from '@mui/material';
import { IconLanguage } from '@tabler/icons-react';
import { useState } from 'react';

export default function LanguageButton() {
  const { i18n, t } = useTranslation();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('i18nextLng', lang);
    handleClose();
  };

  const currentLang = i18n.language === 'en' ? 'EN' : '中';

  return (
    <Box
      sx={{
        ml: 1,
        mr: 1,
        [theme.breakpoints.down('md')]: {
          ml: 0.5,
          mr: 0.5
        }
      }}
    >
      <ButtonBase sx={{ borderRadius: '12px' }} onClick={handleClick}>
        <Avatar
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            transition: 'all .2s ease-in-out',
            borderColor: theme.typography.menuChip.background,
            backgroundColor: theme.typography.menuChip.background,
            '&[aria-controls="menu-list-grow"],&:hover': {
              background: theme.palette.secondary.dark,
              color: theme.palette.secondary.light
            }
          }}
          color="inherit"
        >
          <IconLanguage stroke={1.5} size="1.3rem" />
        </Avatar>
      </ButtonBase>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{
          '& .MuiMenu-paper': {
            backgroundColor: theme.palette.background.default
          }
        }}
      >
        <MenuItem
          onClick={() => changeLanguage('zh')}
          selected={i18n.language === 'zh'}
          sx={{
            minWidth: 120,
            '&.Mui-selected': {
              backgroundColor: theme.palette.mode === 'dark' 
                ? theme.palette.secondary.dark 
                : theme.palette.primary.main,
              color: theme.palette.mode === 'dark'
                ? theme.palette.secondary.light
                : theme.palette.primary.contrastText,
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: theme.palette.mode === 'dark'
                  ? theme.palette.secondary.main
                  : theme.palette.primary.dark
              }
            }
          }}
        >
          <Typography variant="body2">中文简体</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => changeLanguage('en')}
          selected={i18n.language === 'en'}
          sx={{
            minWidth: 120,
            '&.Mui-selected': {
              backgroundColor: theme.palette.mode === 'dark'
                ? theme.palette.secondary.dark
                : theme.palette.primary.main,
              color: theme.palette.mode === 'dark'
                ? theme.palette.secondary.light
                : theme.palette.primary.contrastText,
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: theme.palette.mode === 'dark'
                  ? theme.palette.secondary.main
                  : theme.palette.primary.dark
              }
            }
          }}
        >
          <Typography variant="body2">English</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
}